import { render, staticRenderFns } from "./plan-estudios.vue?vue&type=template&id=2fc71f18&"
import script from "./plan-estudios.vue?vue&type=script&lang=js&"
export * from "./plan-estudios.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports